import React, { lazy } from 'react';
import { SignIn } from './SignIn';

// SignIn stays eagerly bundled: it is the landing route ('/'), the router
// errorElement, and the '*' fallback, so it must paint without waiting on a
// second chunk. Every other screen is code-split and loaded on demand to keep
// the initial JS payload small (see docs — "Reduce unused JavaScript").
const named = (
  loader: () => Promise<Record<string, React.ComponentType<any>>>,
  name: string,
) => lazy(async () => ({ default: (await loader())[name] }));

const FAQ = named(() => import('./FAQ'), 'FAQ');
const Profile = named(() => import('./Profile'), 'Profile');
const Socials = named(() => import('./Socials'), 'Socials');
const Wallet = named(() => import('./Wallet'), 'Wallet');
const ReferralPage = named(() => import('./ReferralPage'), 'ReferralPage');
const FeedbackSubmitted = named(() => import('./FeedbackSubmitted'), 'FeedbackSubmitted');
const Feedback = named(() => import('./Feedback'), 'Feedback');
const ToS = named(() => import('./ToS'), 'ToS');
const Support = named(() => import('./Support'), 'Support');
const PrivacyPolicy = named(() => import('./PrivacyPolicy'), 'PrivacyPolicy');
const EditPersonalInfo = named(() => import('./EditPersonalInfo'), 'EditPersonalInfo');
const TransactionDetails = named(() => import('./TransactionDetails'), 'TransactionDetails');
const TransactionHistory = named(() => import('./TransactionHistory'), 'TransactionHistory');
const PrizeHistory = named(() => import('./PrizeHistory'), 'PrizeHistory');
const WalletSend = named(() => import('./WalletSend'), 'WalletSend');
const DepositRoute = named(() => import('./DepositRoute'), 'DepositRoute');
const WithdrawRoute = named(() => import('./WithdrawRoute'), 'WithdrawRoute');
// Tabs
const More = named(() => import('./tabs/More'), 'More');
const Loans = named(() => import('./tabs/Prizes'), 'Loans');
const Deposits = named(() => import('./tabs/Transfer'), 'Deposits');
const Dashboard = named(() => import('./tabs/Dashboard'), 'Dashboard');
const Notification = named(() => import('./tabs/Notification'), 'Notification');

export const screens = {
  Support,
  ToS,
  FAQ,
  More,
  Loans,
  SignIn,
  Profile,
  Deposits,
  Socials,
  Dashboard,
  Wallet,
  ReferralPage,
  FeedbackSubmitted,
  Notification,
  Feedback,
  PrivacyPolicy,
  EditPersonalInfo,
  TransactionDetails,
  TransactionHistory,
  PrizeHistory,
  WalletSend,
  DepositRoute,
  WithdrawRoute,
};
